import React, { useState } from 'react';
import { Dialog } from '@mui/material';
import { Tenant } from '@restore/services-lib';
import Form from 'components/Form/Form';
import { FormFieldInterface } from 'components/Form/Form.types';
import { UpdateTenantConfigInterface, useTenantsContext } from './tenants.context';
import Gear from '@mui/icons-material/Settings';
import CustomIcon from 'components/Icon/CustomIcon';

const UpdateTenantConfig = ({ tenant }: { tenant: Tenant }): JSX.Element => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id, name: initialName } = tenant;
  const { editTenantConfig } = useTenantsContext();
  const [config, setConfig] = useState<UpdateTenantConfigInterface>({
    id: tenant?.id ?? 0,
    name: tenant?.name ?? '',
    dateFormat: tenant?.dateFormat ?? '',
    pillar1Name: tenant?.pillar1Name ?? '',
    pillar2Name: tenant?.pillar2Name ?? '',
    pillar3Name: tenant?.pillar3Name ?? '',
    pillar4Name: tenant?.pillar4Name ?? '',
    storeRef1Name: tenant?.storeRef1Name ?? '',
    storeRef2Name: tenant?.storeRef2Name ?? '',
    storeRef3Name: tenant?.storeRef3Name ?? '',
    storeStateName: tenant?.storeStateName ?? '',
  });

  const {
    name,
    dateFormat,
    pillar1Name,
    pillar2Name,
    pillar3Name,
    pillar4Name,
    storeRef1Name,
    storeRef2Name,
    storeRef3Name,
    storeStateName,
  } = config;

  const handleUpdateTenant = async () => {
    setLoading(true);
    await editTenantConfig({
      id,
      name,
      dateFormat,
      pillar1Name,
      pillar2Name,
      pillar3Name,
      pillar4Name,
      storeRef1Name,
      storeRef2Name,
      storeRef3Name,
      storeStateName,
    });
    setShow(false);
    setLoading(false);
  };

  const handleUpdateField = (value: string | number, key: keyof Tenant) =>
    setConfig({ ...config, [key]: value });

  const fields: FormFieldInterface[] = [
    {
      label: 'Name',
      value: name,
      onChange: (val) => handleUpdateField(val, 'name'),
    },
    {
      label: 'Date Format',
      value: dateFormat,
      onChange: (val) => handleUpdateField(val, 'dateFormat'),
    },
    {
      label: 'Pillar 1 Name',
      value: pillar1Name!,
      onChange: (val) => handleUpdateField(val, 'pillar1Name'),
    },
    {
      label: 'Pillar 2 Name',
      value: pillar2Name!,
      onChange: (val) => handleUpdateField(val, 'pillar2Name'),
    },
    {
      label: 'Pillar 3 Name',
      value: pillar3Name!,
      onChange: (val) => handleUpdateField(val, 'pillar3Name'),
    },
    {
      label: 'Pillar 4 Name',
      value: pillar4Name!,
      onChange: (val) => handleUpdateField(val, 'pillar4Name'),
    },
    {
      label: 'Store Ref 1 Name',
      value: storeRef1Name!,
      onChange: (val) => handleUpdateField(val, 'storeRef1Name'),
    },
    {
      label: 'Store Ref 2 Name',
      value: storeRef2Name!,
      onChange: (val) => handleUpdateField(val, 'storeRef2Name'),
    },
    {
      label: 'Store Ref 3 Name',
      value: storeRef3Name!,
      onChange: (val) => handleUpdateField(val, 'storeRef3Name'),
    },
    {
      label: 'Store State Name',
      value: storeStateName!,
      onChange: (val) => handleUpdateField(val, 'storeStateName'),
    },
  ];

  return (
    <>
      <CustomIcon onClick={() => setShow(true)} icon={<Gear />} />
      <Dialog open={show} onClose={() => setShow(false)}>
        <Form
          fields={fields}
          title={initialName}
          onSubmit={handleUpdateTenant}
          submitting={loading}
          buttonText='Update Tenant'
        />
      </Dialog>
    </>
  );
};

export default UpdateTenantConfig;
